import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { LegacyButton as BaseButton } from '@/components/LegacyButton';
import { Typography } from '@/components/Typography';

export const ExhibitionPeriodTitle = styled(Typography)`
  ${({ theme }) => css`
    margin-top: 40px;
    margin-bottom: 40px;
    text-transform: uppercase;
    font-size: ${theme.fontSizes.h2Mobile};
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.default};
    font-weight: 600;
    text-align: center;
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.h2};
    }
  `}
`;
export const CategoryWrapper = styled(Box)`
  ${({ theme }) => css`
    padding: 48px 16px;
    ${theme.media.md.up} {
      padding: 40px 0px;
    }
  `}
`;

export const CategoryTitle = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h1Mobile};
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    color: ${theme.colors.default};
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.h1};
    }
  `}
`;

export const CategoryDescriptionWrapper = styled(Box)`
  ${({ theme }) => css`
    max-width: 880px;
    margin: ${theme.spacing(2)} auto ${theme.spacing(0)} auto;
    text-align: center;
    font-family: ${theme.fontFamilies.openSans};
    font-color: ${theme.colors.default};
    line-height: 22px;
    font-size: ${theme.fontSizes.p2};
  `}
`;
export const LoadMoreButton = styled(BaseButton)`
  ${({ theme }) => css`
    cursor: pointer;
    width: 100%;
    ${theme.media.md.up} {
      width: auto;
    }
  `}
`;
export const StyledContainer = styled(Container)`
  position: relative;
  overflow: hidden;
`;

export const LoadMoreCtaOuter = styled(Box)`
  ${({ theme }) => css`
    padding-left: 19px;
    margin: auto;
    position: relative;
    ${theme.media.md.up} {
      padding-left: 0px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin: 0 auto;
      width: 1105px;
    }
  `};
`;
export const PastExhibitionItemsContentWrapper = styled(Box)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(0)};
    overflow: hidden;
  `};
`;
